import { z } from 'zod'

export const apiResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: z.any(),
  errors: z.array(z.string()),
})